/* VIENEV · sekmeler, kaydırmalar, slayt */
(function () {
  function kaydirKur(kap) {
    var iz = kap.querySelector('.pb-iz');
    if (!iz || kap.dataset.kuruldu) return;
    kap.dataset.kuruldu = '1';
    var sol = kap.querySelector('.pb-ok--sol'), sag = kap.querySelector('.pb-ok--sag');
    function guncelle() {
      var tasma = iz.scrollWidth - iz.clientWidth > 4;
      kap.dataset.tasma = tasma ? '1' : '0';
      if (sol) sol.disabled = iz.scrollLeft < 4;
      if (sag) sag.disabled = iz.scrollLeft + iz.clientWidth >= iz.scrollWidth - 4;
    }
    function git(yon) { iz.scrollBy({ left: yon * iz.clientWidth * 0.9, behavior: 'smooth' }); }
    if (sol) sol.addEventListener('click', function () { git(-1); });
    if (sag) sag.addEventListener('click', function () { git(1); });
    iz.addEventListener('scroll', guncelle, { passive: true });
    window.addEventListener('resize', guncelle);
    guncelle();
  }

  function sekmeKur(kok) {
    if (kok.dataset.sekmeKuruldu) return;
    kok.dataset.sekmeKuruldu = '1';
    var sekmeler = kok.querySelectorAll('[role="tab"]');
    sekmeler.forEach(function (s) {
      s.addEventListener('click', function () {
        sekmeler.forEach(function (d) {
          var acik = d === s;
          d.setAttribute('aria-selected', acik ? 'true' : 'false');
          d.tabIndex = acik ? 0 : -1;
          var p = document.getElementById(d.getAttribute('aria-controls'));
          if (p) p.hidden = !acik;
        });
        var p = document.getElementById(s.getAttribute('aria-controls'));
        if (p) p.querySelectorAll('.pb-kaydir').forEach(function (k) { delete k.dataset.kuruldu; kaydirKur(k); });
      });
    });
  }

  function heroKur(h) {
    if (h.dataset.kuruldu) return;
    h.dataset.kuruldu = '1';
    var slaytlar = h.querySelectorAll('.pb-hero__slayt');
    var noktalar = h.querySelectorAll('.pb-hero__nokta');
    if (slaytlar.length < 2) return;
    var i = 0, zaman;
    function goster(n) {
      i = (n + slaytlar.length) % slaytlar.length;
      slaytlar.forEach(function (s, k) { s.classList.toggle('is-aktif', k === i); });
      noktalar.forEach(function (d) { d.setAttribute('aria-current', +d.dataset.no === i ? 'true' : 'false'); });
    }
    function baslat() { clearInterval(zaman); zaman = setInterval(function () { goster(i + 1); }, 6000); }
    noktalar.forEach(function (d) { d.addEventListener('click', function () { goster(+d.dataset.no); baslat(); }); });
    var x0 = null;
    h.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    h.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { goster(i + (dx < 0 ? 1 : -1)); baslat(); }
    });
    h.addEventListener('mouseenter', function () { clearInterval(zaman); });
    h.addEventListener('mouseleave', baslat);
    baslat();
  }


  function paraYaz(kurus, bicim) {
    var tl = (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return bicim ? bicim.replace(/0[,.]00/, tl) : tl + ' TL';
  }
  function birlikteKur(k) {
    if (k.dataset.kuruldu) return; k.dataset.kuruldu = '1';
    var kutular = k.querySelectorAll('input[type=checkbox]'), top = k.querySelector('[data-pb-toplam]');
    function hesap() {
      var t = 0; kutular.forEach(function (c) { if (c.checked) t += +c.dataset.fiyat; });
      if (top) top.textContent = paraYaz(t, top.dataset.bicim);
      var b = k.querySelector('[data-pb-sepete]');
      if (b) b.dataset.idler = [].filter.call(kutular, function (c) { return c.checked; }).map(function (c) { return c.dataset.id; }).join(',');
    }
    kutular.forEach(function (c) { c.addEventListener('change', hesap); }); hesap();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pb-sepete]');
    if (!b || !b.dataset.idler) return;
    e.preventDefault(); b.disabled = true; b.dataset.yazi = b.dataset.yazi || b.textContent;
    var items = b.dataset.idler.split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; b.textContent = 'Sepete eklendi ✓'; setTimeout(function () { b.disabled = false; b.textContent = b.dataset.yazi; }, 2500); })
      .catch(function () { b.disabled = false; b.textContent = 'Eklenemedi, tekrar deneyin'; });
  });

  function hepsi(kok) {
    (kok || document).querySelectorAll('.pb-kaydir').forEach(kaydirKur);
    (kok || document).querySelectorAll('[data-pb-sekmeler]').forEach(sekmeKur);
    (kok || document).querySelectorAll('.pb-hero').forEach(heroKur);
    (kok || document).querySelectorAll('[data-pb-birlikte]').forEach(birlikteKur);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { hepsi(); });
  else hepsi();
  document.addEventListener('shopify:section:load', function (e) { hepsi(e.target); });
})();
